export const subvariablesData = [
  {
    title: '{nome produto}',
    description: 'Descrição pendente.',
    availableFor: [
      'offer_sales',
      'percentage_offer_sales',
      'takepay_offer_sales',
      'cashback_percentage_offer_sales',
      'cashback_absolute_offer_sales',
      'points_offer_sales',
    ],
  },
  {
    title: '{preço 1}',
    description: 'Descrição pendente.',
    availableFor: ['offer_sales', 'cashback_absolute_offer_sales', 'cashback_percentage_offer_sales', 'points_offer_sales'],
  },
  {
    title: '{preço 2}',
    description: 'Descrição pendente.',
    availableFor: ['offer_sales'],
  },
  {
    title: '{desconto}',
    description: 'Descrição pendente.',
    availableFor: ['percentage_offer_sales'],
  },
  {
    title: '{leve}',
    description: 'Descrição pendente.',
    availableFor: ['takepay_offer_sales'],
  },
  {
    title: '{pague}',
    description: 'Descrição pendente.',
    availableFor: ['takepay_offer_sales'],
  },
  {
    title: '{nome do combo}',
    description: 'Descrição pendente.',
    availableFor: ['combo_offer_sales'],
  },
  {
    title: '{cashback absoluto}',
    description: 'Descrição pendente.',
    availableFor: ['cashback_absolute_offer_sales'],
  },
  {
    title: '{cashback percentual}',
    description: 'Descrição pendente.',
    availableFor: ['cashback_percentage_offer_sales'],
  },
  {
    title: '{pontos}',
    description: 'Descrição pendente.',
    availableFor: ['points_offer_sales'],
  },
  {
    title: '{regra min/max}',
    description: 'Descrição pendente.',
    availableFor: ['all'],
  },
  {
    title: '{inicio validade}',
    description: 'Descrição pendente.',
    availableFor: ['all'],
  },
  {
    title: '{fim validade}',
    description: 'Descrição pendente.',
    availableFor: ['all'],
  },
  {
    title: '{regra de expiracao cashback}',
    description: 'Descrição pendente.',
    availableFor: ['cashback_absolute_offer_sales', 'cashback_percentage_offer_sales'],
  },
]

export const bestOfferVariablesData = [
  {
    title: '[1 melhor oferta]',
    description: '1 produto da melhor oferta.',
  },
  {
    title: '[2 melhor oferta]',
    description: '2 produtos da melhor oferta.',
  },
  {
    title: '[3 melhor oferta]',
    description: '3 produtos da melhor oferta.',
  },
  {
    title: '[4 melhor oferta]',
    description: '4 produtos da melhor oferta.',
  },
  {
    title: '[5 melhor oferta]',
    description: '5 produtos da melhor oferta.',
  },
  {
    title: '[6 melhor oferta]',
    description: '6 produtos da melhor oferta.',
  },
  {
    title: '[7 melhor oferta]',
    description: '7 produtos da melhor oferta.',
  },
  {
    title: '[8 melhor oferta]',
    description: '8 produtos da melhor oferta.',
  },
  {
    title: '[9 melhor oferta]',
    description: '9 produtos da melhor oferta.',
  },
  {
    title: '[10 melhor oferta]',
    description: '10 produtos da melhor oferta.',
  },
]

export const defaultVariablesData = [
  {
    title: '[primeiro nome]',
    description: 'Exibe o primeiro nome do cliente.',
  },
  {
    title: '[ultimo nome]',
    description: 'Exibe o último nome do cliente.',
  },
  {
    title: '[data hoje]',
    description: 'Exibe a data de hoje.',
  },
  {
    title: '[dia aniversario]',
    description: 'Exibe a data do aniversário do consumidor.',
  },
  {
    title: '[mes]',
    description: 'Exibe o mês atual.',
  },
  {
    title: '[link de optout]',
    description: 'Renderiza a URL para optout de recebimento e-mail.',
    channels: ['email'],
  },
]

export const getValiditySubvariablesTitle = () => {
  return ['{inicio validade}', '{fim validade}', '{regra de expiracao cashback}']
}

export const getDefaultVariablesTitle = () => {
  return defaultVariablesData.map((variable) => variable.title)
}

export const getBestOfferVariablesTitle = () => {
  return bestOfferVariablesData.map((variable) => variable.title)
}

export const getAllValidVariablesTitle = () => {
  return [...getDefaultVariablesTitle(), ...getBestOfferVariablesTitle()]
}

export const getSubvariablesTitle = () => {
  return subvariablesData.map((subvariable) => subvariable.title)
}

export const getChannelsDefaultVariablesMessages = () => {
  const baseValues = {
    offer_sales: {
      repeatable_text: '{nome produto} de {preço 1}, por {preço 2}, {regra min/max}',
      validity_text: ' do dia {inicio validade} ate {fim validade}',
    },
    percentage_offer_sales: {
      repeatable_text: '{nome produto} com {desconto} de desconto, {regra min/max}',
      validity_text: ' do dia {inicio validade} ate {fim validade}',
    },
    cashback_absolute_offer_sales: {
      repeatable_text: '{nome produto} por {preço 1} com {cashback absoluto} de cashback, {regra min/max}',
      validity_text: ' do dia {inicio validade} ate {fim validade} {regra de expiracao cashback}',
    },
    cashback_percentage_offer_sales: {
      repeatable_text: '{nome produto} por {preço 1} com {cashback percentual} de cashback, {regra min/max}',
      validity_text: ' do dia {inicio validade} ate {fim validade} {regra de expiracao cashback}',
    },
    points_offer_sales: {
      repeatable_text: '{nome produto} por {preço 1} ganhe {pontos} pontos extras, {regra min/max}',
      validity_text: ' do dia {inicio validade} ate {fim validade}',
    },
    takepay_offer_sales: {
      repeatable_text: '{leve} {nome produto} voce paga {pague}, {regra min/max}',
      validity_text: ' do dia {inicio validade} ate {fim validade}',
    },
    combo_offer_sales: {
      repeatable_text: '{nome do combo}, {regra min/max}',
      validity_text: ' do dia {inicio validade} ate {fim validade}',
    },
  }

  const sms = {
    text: {
      ...baseValues,
    },
  }

  const whatsapp = {
    text: {
      ...baseValues,
    },
  }

  const email = {
    text: {
      ...baseValues,
    },
  }

  const push = {
    text: {
      ...baseValues,
    },
    title: {
      ...baseValues,
    },
    inner_message_text: {
      ...baseValues,
    },
    inner_message_title: {
      ...baseValues,
    },
  }

  return { sms, push, whatsapp, email }
}
